export enum PreviewValidationErrors {
    FileIsLarge = "File is too large",
    IncorrectFormat = "You are using unsupported format, please use JPEG or PNG for images, MP4 or WEBM for video",
    IncorrectVideoFormat = "You are using unsupported format, please use MP4 or WEBM for video",
    ImageIncorrectAspectRatio = "Image has incorrect aspect ratio",
    VideoIncorrectAspectRatio = "Video has incorrect aspect ratio",
    CannotLoad = "Cannot load resource",
    TooLongDuration = "Video must be less than 10 seconds",
    GameLensVideoTooShort = "Video is too short. Please upload a 5–10s gameplay clip.",
    GameLensVideoDurationOutOfRange = "Video must be between 5 and 10 seconds for Game Lenses",
    DoesNotExist = "Lens Preview file should be uploaded",
    VideoIncorrectCodec = "Codec is not supported, please use H264. Minimum resolution is 720x1280. Media aspect ratio should be 9:16",
    VideoIncorrectDimensions = "Minimum resolution is 720x1280. Media aspect ratio should be 9:16",
}

export class PreviewValidationError extends Error {
    constructor(message: PreviewValidationErrors) {
        super(message);
        this.name = "PreviewValidationError";
    }
}
